window.main = window.main || {};

main.defineGlobalVars = function () {
	var selectors = {
        // html: document.getElementsByTagName('html')[0],
        // body: document.getElementsByTagName('body')[0],
    };

    main.vars = selectors;
};

main.init = function () {
    main.defineGlobalVars();

    main.window.init();
    main.navigation.init();
    main.cookie.init();
    main.map.init();
    main.dropdown.init();
    main.slider.init();
    main.animations.init();
};

// Initialize main JS on docready
document.addEventListener('DOMContentLoaded',function(){main.init();});
